var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterFallback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 -4 10 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004173",
    d: "M15.7 1c-.2-.6-.8-1-1.4-1H1.5C.9 0 .4.5.1 1S0 2.3.4 2.7l5.9 5.9v9.2c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-9l6.1-6.1c.4-.4.5-1.1.3-1.7z"
  })));
}

export default SvgFilterFallback;